import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
var useStyle = makeStyles({
    overlay: {
        alignItems: "center",
        backgroundColor: "#FFF",
        display: "flex",
        height: "100%",
        justifyContent: "center",
        left: 0,
        position: "absolute",
        top: 0,
        width: "100%",
        zIndex: 1000000,
    },
    overlayContent: {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    overlayTitle: {
        color: "#243F8E",
        fontSize: 20,
        fontStyle: "normal",
        fontWeight: 300,
        marginBottom: 10,
        marginTop: 20,
    },
    spinner: {
        color: "#0DC298",
    },
    spinnerCircle: {
        stroke: "#0DC298",
    },
});
export var LoadingInitial = function () {
    var classes = useStyle();
    return (React.createElement("div", { className: classes.overlay },
        React.createElement("div", { className: classes.overlayContent },
            React.createElement(CircularProgress, { className: classes.spinner, classes: { circle: classes.spinnerCircle }, thickness: 5, size: 70 }))));
};
